(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[414],{

/***/ 2243:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prior-auth-tool",
      function () {
        return __webpack_require__(6689);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var Spinner = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        class: "mr-2 inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-blue border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
        role: "status",
        style: {
            alignSelf: "center"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 6689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ prior_auth_tool; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(1351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Spinner.js
var Spinner = __webpack_require__(6746);
// EXTERNAL MODULE: ./components/SEO/SEO.js + 1 modules
var SEO = __webpack_require__(3976);
// EXTERNAL MODULE: ./layout/Layout.js + 6 modules
var Layout = __webpack_require__(9875);
;// CONCATENATED MODULE: ./components/PreAuthTool/Steps.js

var PriorAuthSteps = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-screen-xl px-4 py-12 pt-6 mx-auto sm:px-6 lg:px-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "text-lg font-semibold",
                    children: "Prior Authorizations"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Learn about our prior authorization process and get helpful information to request coverage approval for your patients. Prior Authorization occurs before planned inpatient admissions and select healthcare services on the prior authorization requirements list below."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-4",
                    children: "Benefits of prior authorization: "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "my-2 ml-6 list-disc",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "to assure members health benefits are administered appropriately"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            children: [
                                "members receive treatments that are proven to be safe and effective for the condition being treated",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "members and their appointed representatives will know coverage decisions before procedures, services or supplies are provided"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "identification of members to pair them with specialty programs with case management and disease management"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "The prior approval process is called prior authorization, or prior authorization (PA). Providers can submit prior authorization requests on behalf of their patients. The prior authorization process is part of the Utilization Review (UR) activities performed by Evry Health. Please note, prior authorizations through the Utilization Review process are not intended to provide medical advice or medical care. Medical advice and care should be discussed with treating providers."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "pt-2",
                    children: [
                        "For information on the",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold",
                            children: "prior authorization for pharmacy benefits"
                        }),
                        ", see this website",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://prime.adaptiverx.com/webSearch/index?key=cnhmbGV4LnBsYW4uUGxhblBkZlR5cGUtODA5",
                            className: "font-bold cursor-pointer text-green",
                            children: "here"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "pt-6 text-lg font-semibold",
                    children: "Screening Criteria"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Reviews for determining medical necessity for inpatient and outpatient services are performed utilizing initial eligibility of benefits for coverage and the following resources or criteria may be used during the determination process for medical necessity review:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "my-2 ml-6 list-disc",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "State and Federal Guidelines"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Proprietary Medical Policies"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "MCG Guidelines"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "American Society of Addiction Medicine Criteria (ASAM) Criteria"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: "Standards for Reasonable Cost Control and Utilization Review for Chemical Dependency Treatment Centers Texas Administrative Code (state.tx.us)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "Other information sources to help to determine medical necessary and benefits coverage may include: Up to Date\xae applicable to the clinical situation, National Comprehensive Cancer Network (NCCN) Guidelines, Reference to other Health Plan policies (comparing accepted standards)."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "pt-6 text-lg font-semibold",
                    children: "Prior Authorization Submission Process:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "pt-2",
                    children: [
                        "For authorization handled by Evry, providers may request authorization by the following process:",
                        " "
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "pt-2",
                    children: [
                        "Step 1: Complete the Texas Standard Prior Authorization Request Form* available for download at",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://www.evryhealth.com/prior-authorization",
                            className: "font-bold cursor-pointer text-green",
                            children: "https://www.evryhealth.com/prior-authorization."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "Step 2: Once completed, please fax the completed prior authorization request form along with the required documentation listed below to request prior authorization. Completion of the form with supporting documentation is required to complete a medical necessity review."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "pt-6 text-lg font-semibold",
                    children: "Documentation Requirements:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "Essential elements necessary to be submitted with prior authorization requests include ALL of the following:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "A. Completed prior authorization request form"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "B. Clinical Documentation supporting the requested services (including but not limited to):"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2 ml-4",
                    children: "i. Medical History (include treatment, diagnostic tests, examination data)"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2 ml-4",
                    children: "ii. Description of treatment plan and treatment to date"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2 ml-4",
                    children: "iii. Diagnostic/Laboratory/Radiology results"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2 ml-4",
                    children: "iv. Clinical notes necessary to certify medical necessity"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "pt-2",
                    children: [
                        "All determinations or requests for more information in order to make an initial UR determination are made in a timely fashion appropriate for the member’s specific condition, not to exceed the timeframes required by NCQA, Texas state, and/or federal regulations. Decisions are communicated both verbally and/or in writing to providers and members, as required by regulations. To verify member eligibility, benefits, or account information, the provider should contact the Plan utilizing the customer service telephone number(s) available on the member’s identification card and/or the Plan website",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "font-bold text-green",
                            href: "https://www.evryhealth.com",
                            children: "www.evryhealth.com."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "pt-6 text-lg font-semibold",
                    children: "Prior Authorization Requirement List:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "pt-2",
                    children: [
                        "All Requirements are effective as of 06/01/2022. For a list of updated prior authorization requirements for medical services see",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "./prior-auth-list-updates",
                            className: "font-bold text-green",
                            children: "prior authorization list updates for medical services"
                        }),
                        ". Visit Prior Authorization (",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "font-bold text-green",
                            href: "https://www.evryhealth.com",
                            children: "www.evryhealth.com."
                        }),
                        ") for a list of services requiring authorization."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "pt-2",
                    children: [
                        "prior authorization is required before the service is provided in non-emergent situations.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "underline",
                            children: "Retroactive requests will be denied unless there are extenuating circumstances"
                        }),
                        ". All prior authorizations should be requested using Evry Health Plan’s request form. Supporting documentation (e.g., notes and lab or radiology findings) should be sent with all prior authorization requests."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2",
                    children: "Prior Authorization Form: www.evryhealth.com | Phone: 1(855)579-3879 | Medical Fax: 1(325)603-0541"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pt-2 pb-6",
                    children: "Please call to check the status of an existing authorization or inquire if a procedure or healthcare service requires prior authorization."
                })
            ]
        })
    });
};
/* harmony default export */ var Steps = (PriorAuthSteps);

;// CONCATENATED MODULE: ./components/PreAuthTool/Table.js

var PriorAuthTable = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "preAuthTable",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-8 lg:grid lg:grid-cols-4 lg:gap-8 lg:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "lg:col-span-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-4xl tracking-tight font-extralight text-darkBlue",
                                            children: "Services Requiring Prior Authorization"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "list-disc ml-4 mt-6 text-grey font-[sans-serif]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Services being performed in the Emergency Department do NOT require prior authorization."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "ALL services being performed or ordered by a non-participating provider REQUIRES prior authorization for members with EPO coverage."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "Admission to an inpatient facility, intensive outpatient (IOP), partial hospitalization (PHP), and residential treatment center (RTC) that are not directly from an ER. Emergency screening and stabilization services are not subject to authorization."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: "See below for additional services requiring authorization."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "lg:col-span-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "inline-block mt-6 font-bold",
                                        children: "This list may not be all-inclusive. Please call if you are uncertain whether a referral is necessary, or a provider is participating."
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "py-8 text-2xl text-center text-blue-dark md:text-4xl md:py-10",
                            children: "Services Requiring Authorization"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                            className: "m-auto md:mb-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                    className: "table-border-body",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        className: "text-left font-[sans-serif]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "w-1/3 h-24 pl-4 text-base md:text-2xl text-blue",
                                                children: "Authorization Service Category"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                className: "w-1/3 h-24 text-base md:text-2xl text-green",
                                                children: "Comments"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                    className: "blue-border-body text-grey",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Admissions"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "tex-base",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "ALL"
                                                            }),
                                                            " planned or scheduled inpatient admissions, includes medical, behavioral health, surgical admissions, hospice, including transfers from one facility to another"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Acute Rehabilitation"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "tex-base",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "ALL"
                                                            }),
                                                            " Inpatient Rehabilitation, Long Term Acute Care Hospital, Skilled Nursing Facilities"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Ambulance or Air/Water Transport"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "Ambulance or Air/Water Ambulance (Non-Emergent transport or transfer generally not covered)"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Any Experimental/ Investigational Services"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "Experimental/ Investigational medical and surgical procedures, equipment, and medications"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Behavioral Health Services"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    className: "md:pl-4 lg:pl-4 xl:pl-4 md bg-torquoise:pr-4 lg:pr-4 xl:pr-4 py- bg-sandWhite",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base",
                                                            children: "Behavioral Health Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: "pl-4 md:list-disc md:pl-8",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Applied Behavioral Analysis (ABA)"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Electroconvulsive Therapy (ECT) Applied"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Neuropsychological and Psychological Testing"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Intensive outpatient program (IOP)"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Partial Hospitalization (PHP)"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                    children: "Residential treatment center (RTC)"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Clinical trials"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "All clinical trials including cancer and clinical innovation"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Dental"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "All dental related services. Generally not covered."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Dialysis"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "All services"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Durable Medical Equipment & Prosthetics"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "text-base md:list-disc md:pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "All DME Rental"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Some items require authorization."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Hematology and Oncology"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "Cancer treatment including chemotherapy, radiation, and surgery; Submit treatment plan as soon as known to facilitate rapid approval of necessary services"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Imaging Advanced & Diagnostic Procedures"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "Arteriogram, Angiograms, CT/CTA scans, MRIs/MRAs, PET scans (exception breast MRI doesn’t require prior authorization)"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Gene Therapy and Molecular Diagnostic Testing"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "py-10 text-base md:list-disc md:pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Cancer treatment including chemotherapy, radiation, and surgery; Submit treatment plan as soon as known to facilitate rapid approval of necessary services"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "All gene therapy"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "All molecular diagnostic testing and genetic testing"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "In network lab: Quest Diagnostics and Bioreference (see website for up to date in network provider information)"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "font-bold",
                                                            children: [
                                                                "Home Services* ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " (plan specific benefit)"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "pt-6 text-base",
                                                            children: [
                                                                "In network home health: see provider ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " directory for up to date information"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "py-10 text-base md:list-disc md:pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Home care: skilled nursing, non skilled nursing, extended home care, hemodialysis, home medical visits, ST/OT/OT services"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Home Infusion therapy services: hydration, nutrition, medications including antibiotics"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Hospice services (inpatient and home services after first 6 months)"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Medical foods or enteral nutrition: oral foods generally not a covered benefit"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-base font-bold",
                                                        children: [
                                                            "The following surgeries when",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            " performed in an Inpatient,",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            " Outpatient, or office location."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "py-10 text-base md:list-disc md:pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Back injections (ESI, RFA, MBB, Facet, ect.)"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Bariatric Surgery"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Blepharoplasty - Brow Lift"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Breast Procedures"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "All Cosmetic surgery: not covered when performed to improve appearance"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "All infusions"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Hyperbaric oxygen therapy"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Photodynamic therapy"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Spine Procedures"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Neurostimulators"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Ophthalmologic procedures"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Some Joint Surgeries (Knee, Hip, Shoulder)"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Some Ear Nose and Throat, Oral-Maxo facial, Integumentary, Gastrointestinal, Female and Male Genital, Reproductive, Ophthalmologic, Orthopedic, Neurological, Fertility"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "CAR-T Cell therapy procedures"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "font-bold",
                                                        children: [
                                                            "Miscellaneous, Unlisted Codes ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "and T Codes"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "Miscellaneous, unlisted codes and T codes are not covered, unless otherwise stated in the provider’s contract."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "font-bold",
                                                        children: [
                                                            "Physician Administered Drugs:",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "Some Specialty Rx/Infusions"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base",
                                                        children: "Most drugs require prior authorization eg. biologicals, supportive care drugs, immunoglobulins, viscosupplementation, etc. Please see the list below for common examples, call Evry Health to confirm if physician administered drug is not listed below."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-base font-bold",
                                                        children: [
                                                            "Plan Specific Provisions:",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            " Check member benefit/",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "eligibility for eligibility."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-8 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: "text-base md:list-disc md:pl-4",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Child Developmental Delays for rehabilitative and habilitative services"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Home Health which includes a limit to 60 visits per calendar year combined modalities"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Treatment of Mental or Emotional Illness or Disorder when confined to a hospital or Psychiatric Day Treatment Facility"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "In-Vitro Fertilization/Fertility"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Speech and Hearing Assistance"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Bariatric Surgery"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Transgender Services"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "font-bold",
                                                        children: [
                                                            "Transplants and Transplant",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            " related services"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                    className: "md:pl-4 md:pr-4 lg:pr-4 xl:pr",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "text-base",
                                                            children: "All Transplants"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: "pt-6 ml-8 list-disc",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Includes Transplant Evaluations, Pre- & Post- Operative Services/Care"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                            className: "border-white border-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-10 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr-4 bg-torquoise",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-base font-bold",
                                                        children: "Reporting"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                    className: "py-8 md:pl-4 lg:pl-4 xl:pl-4 md:pr-4 lg:pr-4 xl:pr bg-sandWhite",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "Evry tracks the number of prior authorization requests received and makes available prior authorization approval and denial rates on a yearly basis. These",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://api.evryhealth.com/api/v1/Marketing/GetFileContent?id=CE2E78AF-B94C-4CDC-9352-2DA91978BCC3",
                                                                className: "font-bold text-green",
                                                                children: "statistics"
                                                            }),
                                                            " ",
                                                            "on the previous year are available 2nd quarter of current year.",
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Table = (PriorAuthTable);

// EXTERNAL MODULE: ./components/Uploader/Dropbox.js
var Dropbox = __webpack_require__(8369);
// EXTERNAL MODULE: ./constants.js
var constants = __webpack_require__(8148);
// EXTERNAL MODULE: ./utils/recaptcha.js
var recaptcha = __webpack_require__(3575);
// EXTERNAL MODULE: ./hooks/useRecaptchaLoader.js
var useRecaptchaLoader = __webpack_require__(2219);
;// CONCATENATED MODULE: ./pages/prior-auth-tool.js















var PreAuthRequestLookup = function(param) {
    var click = param.click, isShown = param.isShown, closeModal = param.closeModal, successfulSubmission = param.successfulSubmission, failedSubmission = param.failedSubmission;
    var ref = (0,react.useState)([
        "emergency"
    ]), questionIds = ref[0], setQuestionIds = ref[1];
    var ref1 = (0,react.useState)(0), _ = ref1[0], render = ref1[1];
    var ref2 = (0,react.useState)(null), componentToRender = ref2[0], setComponentToRender = ref2[1];
    var isDocDefined = typeof document !== "undefined";
    // ensure recaptcha v3 script loads on pages using recaptcha
    var ref3 = (0,useRecaptchaLoader/* default */.Z)(), recaptchaLoaded = ref3.loaded, recaptchaError = ref3.error;
    if (isDocDefined) if (isShown) {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "unset";
    }
    var handleAnswerChange = function(question, answer) {
        if (questionIds.at(-1) !== question) questionIds.pop();
        questionnaire[question].selection = answer;
        render(function(prev) {
            return prev + 1;
        });
        var nextQuestion = questionnaire[question].nextQuestion[answer];
        if (typeof nextQuestion === "string") {
            setComponentToRender(null);
            if (!questionIds.includes(nextQuestion)) setQuestionIds((0,_to_consumable_array/* default */.Z)(questionIds).concat([
                nextQuestion
            ]));
        }
        if (typeof nextQuestion === "object") {
            if (questionIds.length > 1) {
                var complimentNextQuestionKey = Object.keys(questionnaire[question].nextQuestion).filter(function(key) {
                    return key !== answer;
                })[0];
                var complimentNextQuestionValue = questionnaire[question].nextQuestion[complimentNextQuestionKey];
                if (questionIds.includes(complimentNextQuestionValue)) {
                    var nextQuestionIndex = questionIds.indexOf(complimentNextQuestionValue);
                    var remainingQuestions = questionIds.slice(nextQuestionIndex);
                    var nextQuestionIds = questionIds.filter(function(questionId) {
                        return !remainingQuestions.includes(questionId);
                    }).filter(Boolean);
                    remainingQuestions.forEach(function(questionId) {
                        questionnaire[questionId].selection = null;
                    });
                    setQuestionIds((0,_to_consumable_array/* default */.Z)(nextQuestionIds));
                }
            }
            setComponentToRender(nextQuestion);
        }
    };
    var renderQuestion = function(questionId) {
        var question = questionnaire[questionId];
        var description = question === null || question === void 0 ? void 0 : question.question;
        var options = question === null || question === void 0 ? void 0 : question.enum;
        var selection = question === null || question === void 0 ? void 0 : question.selection;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "px-4 py-2",
                    children: description
                }),
                options === null || options === void 0 ? void 0 : options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "text-center ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            className: "accent-orange",
                            type: "radio",
                            name: questionId,
                            value: option,
                            checked: selection === option,
                            onChange: function() {
                                return handleAnswerChange(questionId, option);
                            }
                        })
                    });
                })
            ]
        }, questionId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute inset-0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "object-cover w-full h-full",
                                                src: "videocallAtDesk.png",
                                                alt: "Healthcare provider on a video call"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                className: "text-3xl tracking-tight md:text-5xl text-darkBlue",
                                                children: [
                                                    "Prior Auth Request and Lookup ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-globeGreen",
                                                        children: "Check if Prior Auth is required."
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        id: "preAuthTool",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-screen-xl px-4 pt-10 mx-auto sm:px-6 lg:px-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "p-2 bg-green-light md:p-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "pb-4 text-xl font-bold tracking-tight uppercase md:text-3xl text-green",
                                        children: "Check if a prior authorization request is required"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-[#f9f1c6] text-[#6c4a00] text-left p-4 mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-bold",
                                                    children: "DISCLAIMER"
                                                }),
                                                ": All attempts are made to provide the most current information on the Prior Auth Needed Tool. However, this does NOT guarantee payment. Payment of claims is dependent on eligibility, covered benefits, provider contracts, correct coding and billing practices. For specific details, please refer to the provider manual. If you are uncertain that prior authorization is needed, please contact at 855-579-3879."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative overflow-x-auto border shadow-md border-green",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                            className: "w-full text-left text-gray-500 border-collapse md:text-md dark:text-gray-400",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                    className: "text-sm text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 border-b-1 border-green",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "px-4 py-2",
                                                                children: "Types of Services"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "text-center w-14",
                                                                children: "Yes"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                className: "text-center w-14",
                                                                children: "No"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                                    children: questionIds.map(function(questionId) {
                                                        if (typeof questionId === "string") {
                                                            return renderQuestion(questionId);
                                                        }
                                                        return questionId;
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    componentToRender
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var prior_auth_tool = (PreAuthRequestLookup);
var CodeCheck = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(""), code = ref[0], setCode = ref[1];
    var ref1 = (0,react.useState)(), codeAuth = ref1[0], setCodeAuth = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)({
        show: false,
        title: "",
        message: "",
        subMessage: "",
        showUpload: false
    }), alert = ref4[0], setAlert = ref4[1];
    var checkCode = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var token, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setError(null);
                        setCodeAuth(null);
                        setLoading(false);
                        setAlert({
                            show: false,
                            title: "",
                            message: "",
                            subMessage: "",
                            showUpload: false
                        });
                        setAlert({
                            show: false
                        });
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,recaptcha/* getRecaptchaV3Token */.o)("check_if_auth_required")
                        ];
                    case 2:
                        token = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err);
                        setLoading(false);
                        return [
                            2
                        ];
                    case 4:
                        return [
                            2,
                            fetch("".concat(constants/* BASE_URL */._, "/Marketing/CheckIfAuthRequired"), {
                                method: "POST",
                                body: JSON.stringify({
                                    id: code.replace(/\s+/g, ""),
                                    captcha_token: {
                                        token: token,
                                        version: "v3",
                                        provider: 1
                                    }
                                }),
                                headers: {
                                    "content-type": "application/json"
                                }
                            }).then(function(res) {
                                if (!res.ok) {
                                    var error = new Error(res.statusText);
                                    throw error;
                                }
                                return res.json();
                            }).then(function(json) {
                                return setCodeAuth(json);
                            }).catch(function(err) {
                                setError(err);
                                if (err.json) {
                                    return err.json.then(function(json) {
                                        error.value.message = json.message;
                                    });
                                }
                            }).then(function() {
                                return setLoading(false);
                            })
                        ];
                }
            });
        });
        return function checkCode() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (codeAuth) {
            if (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.is_valid_procedureCode) {
                var isCodeNotCovered = (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_note) === "Code is not a covered service";
                if (codeAuth.auth_required) {
                    setAlert({
                        show: true,
                        title: (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.description) ? "Procedure: ".concat(codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.description, " | Code: ").concat(codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.procedure_code) : null,
                        message: codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_flag,
                        subMessage: (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_note) ? "".concat(codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_note, ".") : undefined,
                        showUpload: true
                    });
                } else {
                    setAlert({
                        type: isCodeNotCovered ? "error" : "info",
                        show: true,
                        title: (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.description) ? "Procedure: ".concat(codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.description, " | Code: ").concat(codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.procedure_code) : null,
                        message: (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_flag) || "No prior authorization required.",
                        subMessage: (codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_note) ? "".concat(codeAuth === null || codeAuth === void 0 ? void 0 : codeAuth.auth_required_note, ".") : undefined,
                        showUpload: false
                    });
                }
            } else {
                setAlert({
                    show: true,
                    message: "Code not found. Please try again or contact customer support at 1-855-579-3879.",
                    showUpload: false
                });
            }
        }
    }, [
        codeAuth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[1px]"
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full mt-8 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "pb-2 text-center text-grey md:text-left",
                        children: [
                            "What codes are associated with the request? Can`t find a code?",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "inline-block underline text-green decoration-solid",
                                href: "#preAuthTable",
                                children: "Check our prior authorization table list."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row justify-between mt-2 border-1 border-green",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                className: "w-full px-8 py-3 text-lg bg-transparent placeholder:text-lightGrey",
                                type: "text",
                                max: "15",
                                value: code,
                                onChange: function(e) {
                                    setCode(e.target.value);
                                },
                                placeholder: "Code"
                            }),
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                className: "px-2 text-lg font-medium text-white bg-green",
                                onClick: function() {
                                    return checkCode();
                                },
                                children: "Check"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                show: alert.show,
                type: alert.type,
                title: alert.title,
                message: alert.message,
                subMessage: alert.subMessage,
                showUpload: alert.showUpload
            })
        ]
    });
};
var Alert = function(param) {
    var type = param.type, message = param.message, show = param.show, showUpload = param.showUpload, subMessage = param.subMessage, title = param.title;
    var ref = (0,react.useState)("selectFiles"), uploadStatus = ref[0], setUploadStatus = ref[1];
    var ref1 = (0,react.useState)([]), fileList = ref1[0], setFileList = ref1[1];
    var ref2 = (0,react.useState)(false), openOverlay = ref2[0], setOpenOverlay = ref2[1];
    (0,react.useEffect)(function() {
        return function() {
            setUploadStatus("selectFiles");
            setFileList([]);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (uploadStatus === "success" || uploadStatus === "error") setOpenOverlay(true);
    }, [
        uploadStatus
    ]);
    if (show) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(type === "info" ? "bg-[#e0f8ff] border border-blue" : "bg-[#fffafa] border border-red", " mt-4 shadow-md flex max-lg:flex-col"),
                    role: "alert",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(type === "info" ? "text-[#1c3869]" : "text-[#d2322d]", " flex flex-col items-center flex-1 mx-4 py-4 text-lg text-left "),
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    marginBottom: "10px"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    message,
                                    " ",
                                    showUpload && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            "Click",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://content.evryhealth.com/Files/Prior%20Authorization%20Request%20Form.pdf",
                                                className: "font-bold underline text-[#d2322d] animate-pulse",
                                                children: "here"
                                            }),
                                            " ",
                                            "to download the Prior Auth form. Once completed, please upload the request form along with supporting documentation (e.g. notes and lab or radiology findings) below."
                                        ]
                                    })
                                ]
                            }),
                            subMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                style: {
                                    fontSize: "16px",
                                    color: "gray",
                                    marginTop: "10px"
                                },
                                children: subMessage
                            })
                        ]
                    })
                }),
                showUpload && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center w-full h-full mt-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex flex-col max-w-[550px] h-full w-full",
                        children: [
                            openOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(StatusOverlay, {
                                status: uploadStatus,
                                fileList: fileList,
                                setOpenOverlay: setOpenOverlay
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropbox/* default */.Z, {
                                uploadStatus: uploadStatus,
                                setUploadStatus: setUploadStatus,
                                setFileList: setFileList
                            }),
                            uploadStatus === "selectFiles" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-[#dbe9fd] mt-2 p-4 border-[#006BFF] border-2 text-left",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Attach your Prior authorization request form with supporting clinical documentation here. You can submit documents in",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: [
                                                " ",
                                                "txt, doc, pdf, jpg and png",
                                                " "
                                            ]
                                        }),
                                        " ",
                                        "file formats. Please note that the maximum file size is",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: 600
                                            },
                                            children: "30mb"
                                        }),
                                        "."
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        });
    }
    return null;
};
var StatusOverlay = function(param) {
    var status = param.status, fileList = param.fileList, setOpenOverlay = param.setOpenOverlay;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            zIndex: 10
        },
        className: "absolute inset-0 flex flex-col items-center justify-center flex-1 text-center bg-opacity-90 bg-white-light p-9 backdrop-blur-sm",
        children: [
            status === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-3xl",
                        children: "Successfully uploaded"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center mt-4 p-9",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xl",
                                children: "Here's a summary of the uploaded files"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col items-center w-full p-4 mt-4 overflow-hidden overflow-y-auto max-h-40",
                                children: fileList.map(function(file) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "p-2 mb-2 rounded-md bg-[#dbf4db] drop-shadow-md border-[#5a8e5a] border-1",
                                        children: file
                                    });
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-3xl",
                        children: "Failed to upload"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xl text-center p-14",
                        children: "Unfortunately something went wrong uploading your files. Please contact customer service for further assistance"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "w-[100px] p-2 px-4 mt-2 transition-all duration-200 border shadow-sm bg-[#007bff] border-blue hover:bg-[#1985fa] text-white-light disabled:bg-lightGrey disabled:text-black-default disabled:cursor-not-allowed",
                onClick: function() {
                    return setOpenOverlay(false);
                },
                children: "Close"
            })
        ]
    });
};
var questionnaire = {
    emergency: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this an emergency?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "Please call 9-1-1. No prior authorization is required",
                showUpload: false,
                show: true
            }),
            No: "electiveCare"
        }
    },
    electiveCare: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for elective care where an inpatient stay will be required?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                show: true,
                showUpload: true
            }),
            No: "bariatricTransgenderFertilityCare"
        }
    },
    bariatricTransgenderFertilityCare: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for care related to bariatric surgery, transgender care, fertility care, or care associated with child development delays?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "Benefit limitations may apply. Please call Member Services or your care guide to determine if there are covered services in your benefit plan.",
                showUpload: false,
                show: true
            }),
            No: "outOfNetworkProvider"
        }
    },
    outOfNetworkProvider: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "If you have EPO/EPBP benefits, is this for elective care provided by an out-of-network provider?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                show: true,
                showUpload: true
            }),
            No: "infusionCancerBasedCare"
        }
    },
    infusionCancerBasedCare: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for infusion-based or cancer-based care, including chemotherapy, radiation, biologic, drug therapy?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                show: true,
                showUpload: true
            }),
            No: "retailClinicCare"
        }
    },
    retailClinicCare: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for care to be received in a retail clinic, non-urgent setting?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "No prior authorization required.",
                showUpload: false,
                show: true
            }),
            No: "chiropractorAcupuncturistCare"
        }
    },
    chiropractorAcupuncturistCare: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for care to be delivered by either a chiropractor or an acupuncturist?",
        nextQuestion: {
            Yes: "chiropractorAcupuncturistCare2",
            No: "skilledNursingFacilityCare"
        }
    },
    chiropractorAcupuncturistCare2: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Benefit limitation may apply. The benefit plan design currently restricts members to 5 office visits before prior authorization is required. Is this your 6th or greater visit to a chiropractor or acupuncturist?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                show: true,
                showUpload: true
            }),
            No: "skilledNursingFacilityCare"
        }
    },
    skilledNursingFacilityCare: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for care to be delivered within a skilled nursing facility?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "No prior authorization required IF you have used less than 25 days of skilled nursing to date this calendar year. If this care is expected to go beyond the 25 days limit, prior auth is required",
                showUpload: false,
                show: true
            }),
            No: "homeCaregiver"
        }
    },
    homeCaregiver: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for care to be delivered by a home care aid or similar home-based caregiver?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "No prior authorization required if you have used less than 60 days of home-based care to date this calendar year. If this care is expected to go beyond the 60 days limit, prior auth is required",
                showUpload: false,
                show: true
            }),
            No: "rehabilitationTherapy"
        }
    },
    rehabilitationTherapy: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Is this for physical therapy or occupational therapy?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "No prior authorization required if you have used less than 35 care visits of this type of rehabilitation to date this calendar year. If this care is expected to go beyond the 35 visits limitation, prior auth is required",
                showUpload: false,
                show: true
            }),
            No: "inquiryAnswered"
        }
    },
    inquiryAnswered: {
        enum: [
            "Yes",
            "No"
        ],
        selection: null,
        question: "Has your inquiry been answered by the questions above?",
        nextQuestion: {
            Yes: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                message: "Thank you for using the Prior Auth Tool. Please contact us for further support if needed.",
                showUpload: false,
                show: true
            }),
            No: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeCheck, {})
        }
    }
};


/***/ }),

/***/ 1351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,160,875,821,774,888,179], function() { return __webpack_exec__(2243); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);